import { render, staticRenderFns } from "./HistoryList.vue?vue&type=template&id=36cb126a&"
import script from "./HistoryList.vue?vue&type=script&lang=ts&"
export * from "./HistoryList.vue?vue&type=script&lang=ts&"
import style0 from "./HistoryList.vue?vue&type=style&index=0&id=36cb126a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports